import axios from 'axios';
import { encryptPayload, decryptPayload } from '../utils/apiEncryption';
import { useState } from 'react';
import { setEncryptedCookie, getDecryptedCookie, removeCookie } from '../utils';
import authApi from '../services/auth';
import { showLoader, hideLoader } from '../redux/loader/action';
import { showSnackbar } from '../redux/snackbar/action';
import { setAuth } from '../redux/common/action';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Create Axios instance
const axiosInstance = axios.create({
    withCredentials: true // Include cookies for cross-origin requests
});

// const [errCode, setErrCode] = useState(null)

// Request Interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        if (config.data) {
            const encrypted = encryptPayload(config.data);
            if (encrypted) {
                config.data = encrypted.encryptedData; // Replace the data with encrypted payload
                // Send IV in the headers
                config.headers['key'] = encrypted.iv;
            } else {
                console.error('Failed to encrypt request payload');
            }
        }
        return config;
    },
    async (error) => {
        console.error('Request error:', error);
        if (error?.status === 401 || error?.status === 403) {
            try {
                await authApi.refreshToken();
            } catch (err) {
                console.error('Failed to refresh access token:', err);
                await authApi
                    .logoutUser()
                    .then((res) => {
                        useDispatch(hideLoader());
                        if (res?.data?.status === true) {
                            useDispatch(
                                showSnackbar({
                                    message: res?.data?.message || 'Logged Out successfully',
                                    autoHideDuration: 3000,
                                    anchorOrigin: {
                                        vertical: 'top',
                                        horizontal: 'right'
                                    },
                                    variant: 'success'
                                })
                            );
                            useDispatch(setAuth({ isAuthenticated: false }));
                            removeCookie('at');
                            removeCookie('rt');
                            removeCookie('bid');
                            removeCookie('bn');
                            removeCookie('il');
                            removeCookie('lug');
                            removeCookie('ssoUid');
                            // removeCookie("ssoid");
                            removeCookie('un');
                            removeCookie('ui');
                            removeCookie('abc');
                            removeCookie('buslap');
                            removeCookie('fdf');
                            removeCookie('def');
                            removeCookie('id');
                            removeCookie('ids');
                            removeCookie('name');
                            removeCookie('proid');
                        }
                    })
                    .catch((error) => {
                        useDispatch(hideLoader());
                    });
            }
        }

        return Promise.reject(error);
    }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
    async (response) => {
        try {
            const encryptedPayload = response.data; // Encrypted response payload
            const ivKey = response.headers['key']; // IV from response header

            if (encryptedPayload && ivKey) {
                const decryptedData = decryptPayload(encryptedPayload, ivKey);
                if (decryptedData) {
                    response.data = decryptedData; // Replace encrypted data with decrypted one
                } else {
                    console.error('Failed to decrypt response payload');
                }
            }
        } catch (error) {
            console.error('Error processing response decryption:', error);
        }

        return response;
    },
    async (error) => {
        console.error('Response error:', error);

        if (error?.status === 401 || error?.status === 403) {
            try {
                await authApi.refreshToken();
            } catch (err) {
                console.error('Failed to refresh access token:', err);
                await authApi
                    .logoutUser()
                    .then((res) => {
                        useDispatch(hideLoader());
                        if (res?.data?.status === true) {
                            useDispatch(
                                showSnackbar({
                                    message: res?.data?.message || 'Logged Out successfully',
                                    autoHideDuration: 3000,
                                    anchorOrigin: {
                                        vertical: 'top',
                                        horizontal: 'right'
                                    },
                                    variant: 'success'
                                })
                            );
                            useDispatch(setAuth({ isAuthenticated: false }));
                            removeCookie('at');
                            removeCookie('rt');
                            removeCookie('bid');
                            removeCookie('bn');
                            removeCookie('il');
                            removeCookie('lug');
                            removeCookie('ssoUid');
                            // removeCookie("ssoid");
                            removeCookie('un');
                            removeCookie('ui');
                            removeCookie('abc');
                            removeCookie('buslap');
                            removeCookie('fdf');
                            removeCookie('def');
                            removeCookie('id');
                            removeCookie('ids');
                            removeCookie('name');
                            removeCookie('proid');
                        }
                    })
                    .catch((error) => {
                        useDispatch(hideLoader());
                    });
            }
        }

        return Promise.reject(error);
    }
);

// axiosInstance.interceptors.response.use(
//   (response) => {
//     try {
//       // Log all headers to verify visibility
//       console.log("Response Headers:", response.config.headers);

//       const encryptedPayload = response.data; // Encrypted response payload
//       const ivKey = response.headers['content-length'];
//       console.log("Response Headers:", ivKey);

//       if (encryptedPayload && ivKey) {
//         const decryptedData = decryptPayload(encryptedPayload, ivKey);
//         if (decryptedData) {
//           response.data = decryptedData; // Replace with decrypted data
//         } else {
//           console.error("Failed to decrypt response payload");
//         }
//       }
//     } catch (error) {
//       console.error("Error processing response decryption:", error);
//     }

//     return response;
//   },
//   (error) => {
//     console.error("Response error:", error);
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
